import { connect } from 'react-redux';
import { State } from '../../../../reducer';
import { withRouter } from 'react-router-dom';
import ReceiptsTab from '../components/receiptsTab';
import { getReceipts } from '../actions';
import { getReceipt } from '../../receipt/actions';
import { getReceiptsSelector } from '../selectors';
import { getActiveReceiptSelector } from '../../receipt/selectors';

const mapStateToProps = (state: State) => ({
    receipts: getReceiptsSelector(state),
    activeReceiptId: getActiveReceiptSelector(state),
});

const mapDispatchToProps = {
    getReceipts,
    getReceipt,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ReceiptsTab)
);

